// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import PaidHero from '../components/theme-paid/PaidHero'
import PaidTextAndImage from '../components/theme-paid/PaidTextAndImage'
import {
  getHeroSectionFieldsFromContentful,
  getTextAndImageSectionFieldsFromContentful,
  getTriptychSectionFieldsFromContentful,
  getSubtitleSectionFieldsFromContentful,
} from './extractContentfulFields'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import PaidTriptych from '../components/theme-paid/PaidTriptych'
import PaidSubtitleSection from '../components/theme-paid/PaidSubtitleSection'

export const paidSubtitleSection = (
  node: ContentfulNode,
  options?: { leftAlign?: boolean },
) => {
  const { subtitle, blurb } = getSubtitleSectionFieldsFromContentful(node)

  return (
    <PaidSubtitleSection
      subtitle={subtitle}
      blurb={blurb}
      leftAlign={options && options.leftAlign === true}
    />
  )
}

export const paidHeroSection = (node: ContentfulNode) => {
  const {
    title,
    description,
    imageUrls,
    cta,
    flags,
  } = getHeroSectionFieldsFromContentful(node)
  return (
    <PaidHero
      title={title}
      description={description}
      imageUrls={imageUrls}
      cta={cta}
      flags={flags}
    />
  )
}

export const paidTextAndImageSection = (node: ContentfulNode) => {
  const {
    title,
    description,
    imageUrls,
    imageAlts,
    reverse,
    cta,
  } = getTextAndImageSectionFieldsFromContentful(node)
  return (
    <PaidTextAndImage
      title={title}
      description={description}
      imageUrls={imageUrls}
      imageAlts={imageAlts}
      reverse={reverse}
      cta={cta}
    >
      {node[subtitleNodeName] && paidSubtitleSection(node[subtitleNodeName])}
    </PaidTextAndImage>
  )
}

export const paidTriptych = (node: ContentfulNode) => {
  const { sections, reverse, flags } = getTriptychSectionFieldsFromContentful(
    node,
  )
  return (
    <>
      <PaidTriptych sections={sections} reverse={reverse} flags={flags}>
        {node[subtitleNodeName] && paidSubtitleSection(node[subtitleNodeName])}
      </PaidTriptych>
    </>
  )
}
